// extracted by mini-css-extract-plugin
export default {"root":"bOOTQDFTKAgZOIS9GbsA","placeHolderShimmer":"RLwYcPqRR1sEoA3npm8x"};